import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data", "loading", "refetch"];
import { useGetKnowledgeHubConfigQueryQuery } from "./graphql/GetKnowledgeHubConfigQuery.v5.generated";
var useKnowledgeHubConfigQuery = function useKnowledgeHubConfigQuery(_ref) {
  var orgId = _ref.orgId,
    skip = _ref.skip;
  var _useGetKnowledgeHubCo = useGetKnowledgeHubConfigQueryQuery({
      context: {
        clientName: 'v5'
      },
      variables: {
        organizationId: orgId
      },
      skip: skip,
      notifyOnNetworkStatusChange: true
    }),
    data = _useGetKnowledgeHubCo.data,
    loading = _useGetKnowledgeHubCo.loading,
    refetch = _useGetKnowledgeHubCo.refetch,
    knowledgeHubConfigQuery = _objectWithoutProperties(_useGetKnowledgeHubCo, _excluded);
  var khConfigNode = data === null || data === void 0 ? void 0 : data.knowledge_hub_config.knowledge_hub_config;
  var knowledgeHubActivated = khConfigNode === null || khConfigNode === void 0 ? void 0 : khConfigNode.has_knowledge_hub;
  var configAdminNode = khConfigNode === null || khConfigNode === void 0 ? void 0 : khConfigNode.config_admin_detail;
  var configAdmin = configAdminNode ? {
    crehana: configAdminNode.has_crehana_content_available,
    thirdParty: configAdminNode.has_third_party_content_available,
    catalog: configAdminNode.has_catalog_available,
    assignContent: configAdminNode.leader_can_assign_content
  } : undefined;
  return _objectSpread({
    refetch: refetch,
    loading: loading,
    knowledgeHubActivated: knowledgeHubActivated,
    configAdmin: configAdmin
  }, knowledgeHubConfigQuery);
};
export default useKnowledgeHubConfigQuery;